<template>
	<div
		class="availability-day"
		:class="{ 'availability-day--readonly': readonly }">
		<div class="availability-day__name">
			{{ setup.readableDay }}
			<span
				v-if="date"
				class="availability-day__date">
				{{ date.toReadable('$DD $MMMM') }}
			</span>
		</div>
		<div class="availability-day__time">
			<o-label
				size="lg"
				:outline="!setup.availableMorning"
				:color="setup.availableMorning ? 'success' : 'default'"
				@click="setup.handleClick(setup.PERIOD_DAY.Morning)">
				Matin
			</o-label>
			<o-label
				size="lg"
				:outline="!setup.availableAfternoon"
				:color="setup.availableAfternoon ? 'success' : 'default'"
				@click="setup.handleClick(setup.PERIOD_DAY.Afternoon)">
				Après-midi
			</o-label>
			<o-label
				size="lg"
				:outline="!setup.availableNight"
				:color="setup.availableNight ? 'success' : 'default'"
				@click="setup.handleClick(setup.PERIOD_DAY.Night)">
				Nuit
			</o-label>
		</div>
	</div>
</template>

<script setup lang="ts">
import UserProfileAvailabilityDaySetupService from '@/setup/user-profile/UserProfileAvailabilityDaySetupService';
type Emits = {(e: 'update:modelValue', val: Number): void};
const emits = defineEmits<Emits>();
const props = defineProps(UserProfileAvailabilityDaySetupService.props);
const setup = new UserProfileAvailabilityDaySetupService(props, emits);
</script>

<style scoped lang="less">
@import '@/styles/variables.less';
.availability-day {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;

	@media @layoutNavBottom {
		.availability__days & {
			flex-direction: column;
		}
	}


  &:hover {
    background: var(--grey-lighter);
  }

  &__name {
    text-transform: uppercase;
    font-size: 14px;
    font-weight: normal;
    color: var(--grey-dark);
  }

  &__time {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    > .orion-label {
      cursor: pointer;
      .availability-day--readonly & {
        cursor: default;
      }
    }
  }
}
</style>
